import React from 'react';
import { Button } from '../../components/ui/button';
import { Play, Eye, CircleNotch } from '@phosphor-icons/react';
import { StatusDot, StatusBadge } from './StatusIndicators';
import { GROUP_META, extractTxId } from './constants';

const getResultInfo = (result) => {
  if (!result) return null;
  if (result.total !== undefined) return `${result.success ?? 0}/${result.total} accepted`;
  return result.result?.success ? 'Accepted' : null;
};

const ScenarioRow = ({
  scenario,
  result,
  status,
  onRun,
  onCheckStatus,
  onSelect,
  isSelected,
}) => {
  const meta = GROUP_META[scenario.group];
  const txId = extractTxId(result);
  const resultInfo = getResultInfo(result);

  return (
    <div
      data-testid={`cert-scenario-${scenario.id}`}
      className={`flex items-center gap-3 px-4 py-3 border-b border-slate-100 hover:bg-slate-50/50 cursor-pointer transition-colors ${
        isSelected ? 'bg-indigo-50/40 border-l-2 border-l-indigo-500' : ''
      }`}
      onClick={() => onSelect(scenario.id)}
    >
      <StatusDot status={status} />
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2">
          <span className="text-sm font-medium text-slate-800 truncate">
            {scenario.label}
          </span>
          <span
            className="text-[10px] px-1.5 py-0.5 rounded font-medium shrink-0"
            style={{ backgroundColor: `${meta.color}12`, color: meta.color }}
          >
            {meta.label}
          </span>
        </div>
        <p className="text-xs text-slate-400 truncate mt-0.5">{scenario.description}</p>
        {txId && (
          <p className="text-[10px] font-mono text-slate-400 mt-0.5 truncate">TX: {txId}</p>
        )}
      </div>
      <div className="flex items-center gap-2 shrink-0">
        {resultInfo && (
          <span className="text-xs text-slate-500 hidden sm:block">{resultInfo}</span>
        )}
        <StatusBadge status={status} />
        {(status === 'success' || status === 'warning') && txId && (
          <Button
            data-testid={`check-${scenario.id}`}
            size="sm"
            variant="ghost"
            className="h-7 w-7 p-0"
            onClick={(e) => {
              e.stopPropagation();
              onCheckStatus(scenario, result);
            }}
            title="Check processing status"
          >
            <Eye size={14} className="text-slate-500" />
          </Button>
        )}
        <Button
          data-testid={`run-${scenario.id}`}
          size="sm"
          variant={status === 'running' ? 'outline' : 'default'}
          disabled={status === 'running' || status === 'checking'}
          onClick={(e) => {
            e.stopPropagation();
            onRun(scenario);
          }}
          className="h-7 text-xs gap-1"
        >
          {status === 'running' ? (
            <CircleNotch size={12} className="animate-spin" />
          ) : (
            <Play size={12} weight="fill" />
          )}
          {status === 'running' ? 'Running' : 'Run'}
        </Button>
      </div>
    </div>
  );
};

export default ScenarioRow;
